import AdminBookingDetailPage from '@/pages/admin/AdminBookingDetailPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/booking/$bookingId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { bookingId } = Route.useParams();
  return <AdminBookingDetailPage bookingId={bookingId} />;
}
